var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"not-found__wrap"},[_c('p',[_vm._v(" 404 ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('pageNotFoundDescription'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }